<template>
	<div class="pa_10">
		<div class="box_items_area">
			<div class="box_items">
				<div class="box_item mb_4">
					<p>{{ $t('merchant.settlement.name') }}</p>
					<p>{{ merchantInfo.merchant_name }}</p>
				</div>
				<div class="box_item">
					<p>{{ $t('merchant.settlement.id') }}</p>
					<p>{{ merchantInfo.merchant_id }}</p>
				</div>
			</div>
			<div class="box_items2">
				<div class="box_item mb_4">
					<p>{{ $t('merchant.settlement.asset') }}</p>
					<p>
						{{ disconnectInfo.asset_title + ' ' + disconnectInfo.asset_code }}
					</p>
				</div>
				<div class="box_item">
					<p>{{ $t('merchant.settlement.account') }}</p>
					<p>{{ disconnectInfo.account_number }}</p>
				</div>
			</div>
		</div>
		<p class="mb_40 fs_12">{{ $t('modal.message.settlement_disconnect') }}</p>

		<button class="button_bg_blue w100" @click="disconnectAccount">
			{{ $t('merchant.settlement.disconnect') }}
		</button>
	</div>
</template>
<script>
import { deleteMerchantAccount, fetchMerchant } from '@/api/pg';
import { commonError } from '@/common/dialog';

export default {
	name: 'SettlementAccountDisconnect',
	emits: ['successDisconnect'],
	props: {
		manageMerchantInfo: Object,
		disconnectInfo: Object,
	},
	data() {
		return {
			merchantInfo: {},
		};
	},
	computed: {
		isManage() {
			return this.$route.name.includes('management');
		},
	},
	created() {
		if (!this.isManage) {
			this.init();
		} else {
			this.merchantInfo = this.manageMerchantInfo;
		}
	},
	methods: {
		init() {
			this.getMerchantInfo();
		},
		async getMerchantInfo() {
			const { merchant_info } = await fetchMerchant(
				this.$route.params.merchant_seq,
			).catch(commonError);
			this.merchantInfo = merchant_info;
		},
		async disconnectAccount() {
			const params = {
				merchant_seq: this.isManage
					? this.manageMerchantInfo.seq
					: this.$route.params.merchant_seq,
				merchant_account_seq: this.disconnectInfo.seq,
			};
			await deleteMerchantAccount(params)
				.then(() => {
					this.$emit('successDisconnect');
				})
				.catch(commonError);
		},
	},
};
</script>
